export default {
  "discover_your": "",
  "ascendant": "వేద జ్యోతిష్యం ",
  "rising_sign_analysis": "ద్వారా మీ లగ్న రాశి విశ్లేషణ అందించబడుతుంది",
  "ascendant_description": "ఇది మీ వ్యక్తిత్వం, రూపాన్ని మరియు జీవిత మార్గాన్ని నిర్దేశిస్తుంది, . సూర్య, చంద్ర రాశులు కలయిక భవిష్యవాణులు మరియు దైనందిన మార్గదర్శకతను అందిస్తాయి.",
  "exact_time_critical_for_ascendant": "ఖచ్చితమైన లగ్న గణన కోసం సరైన జన్మ సమయం కీలకం",
  "location_essential_for_ascendant": "మీ లగ్న రాశిని నిర్ధారించడానికి ఖచ్చితమైన స్థానం అవసరం",
  "complete_ascendant_analysis": "పూర్తి లగ్న విశ్లేషణ",
  "rising_sign_identification": "లగ్న రాశి గుర్తింపు",
  "personality_traits_analysis": "వ్యక్తిత్వ లక్షణాల విశ్లేషణ",
  "first_impression_insights": "మొదటి అభిప్రాయం అంతర్దృష్టులు",
  "life_path_guidance": "జీవిత మార్గ మార్గదర్శనం",
  "focused_ascendant_analysis_note": "మీ లగ్న రాశి మరియు లగ్న లక్షణాలపై దృష్టి సారించిన ప్రత్యేక విశ్లేషణ.",
  "pay_and_generate_analysis": "చెల్లించి విశ్లేషణ రూపొందించండి",
  "your_rising_sign_detailed": "మీ లగ్న రాశి వివరణాత్మక విభజన",
  "personality_mask_analysis": "వ్యక్తిత్వ ముసుగు మరియు బాహ్య ప్రదర్శన విశ్లేషణ",
  "appearance_and_style_insights": "రూపం మరియు శైలి అంతర్దృష్టులు",
  "life_approach_patterns": "జీవిత దృక్పథం మరియు ప్రవర్తనా నమూనాలు",
  "sample_ascendant_analysis": "నమూనా లగ్న విశ్లేషణ",
  "sample_ascendant_description": "వివరణాత్మక అంతర్దృష్టులతో మీ వ్యక్తిగతీకరించిన లగ్న నివేదిక ఎలా ఉంటుందో ఇది చూపిస్తుంది.",
  "rising_signs": "లగ్న రాశులు",
  "aries_rising": "మేష లగ్నం",
  "taurus_rising": "వృషభ లగ్నం",
  "gemini_rising": "మిథున లగ్నం",
  "cancer_rising": "కర్కాట లగ్నం",
  "leo_rising": "సింహ లగ్నం",
  "virgo_rising": "కన్య లగ్నం",
  "ascendant_analysis_processing": "మా నిపుణ జ్యోతిష్యులచే మీ లగ్న విశ్లేషణ తయారు చేయబడుతోంది.",
  "detailed_ascendant_report_pdf": "వివరణాత్మక లగ్న నివేదిక (PDF ఆకృతి)",
  "rising_sign_characteristics": "లగ్న రాశి లక్షణాలు మరియు గుణాలు",
  "personality_presentation_insights": "వ్యక్తిత్వ ప్రదర్శన అంతర్దృష్టులు",
  "first_impression_analysis": "మొదటి అభిప్రాయం మరియు సామాజిక వ్యక్తిత్వ విశ్లేషణ",
  "life_approach_guidance": "జీవిత దృక్పథం మరియు ప్రవర్తనా మార్గదర్శనం",
  "your_ascendant_analysis_status": "మీ లగ్న విశ్లేషణ స్థితి",
  "processing_your_analysis": "మీ విశ్లేషణను ప్రాసెస్ చేస్తోంది",
  "analysis_processing_message": "మా నిపుణ జ్యోతిష్యులు మీ వ్యక్తిగతీకరించిన లగ్న విశ్లేషణపై పని చేస్తున్నారు."
}
